import { GroupFormComponent } from './group-form/group-form.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GroupComponent } from './group.component';
import { moduleConfigFunc, TnxSharedModule } from 'tnx-shared';
import { GroupRoutes } from './group.routing';

export function declaration() {
    return [GroupComponent, GroupFormComponent];
}

@NgModule({
    imports: [
        TnxSharedModule
    ],
    declarations: declaration(),
    exports: declaration()
})
export class GroupModule {
    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}

@NgModule({
    imports: [GroupModule, GroupRoutes],
    exports: [GroupModule]
})
export class GroupWithRouteModule {
    static forRoot(config?: any): any {
        return {
            ngModule: TnxSharedModule,
            providers: [
                {
                    provide: moduleConfigFunc,
                    useValue: config
                }
            ]
        };
    }
}
